import notificationService from '@/services/notificationService'
const state = {
  listNotifications: [],
  isLoaded: false
}
const getters = {
  listNotifications(state) {
    if (!state.isLoaded) {
      notificationService.list().then(res => {
        const result = []
        const result_error = []
        res.data.forEach(element => {
          if (element.info.noti_flag === 1 && element.status_read === 0) {
            result.push(element)
            if (element.info.error_status === 1 || element.info.error_status === 2) {
              result_error.push(element)
            }
          }
        })
        const array_concat = result_error.concat(result)
        const show_noti = [...new Set(array_concat)]
        state.listNotifications = show_noti.slice(0, 5)
        state.isLoaded = true
      })
    }
    return state.listNotifications
  }
}

const actions = {}
const mutations = {}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
